<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 text-center py-5>
        <span class="head">Find Nearby Beekeepers</span>
      </v-flex>
      <v-flex id="googlemap"> </v-flex>
    </v-layout>
  </div>
</template>
<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";
export default {
  data() {
    return {
      icons:"",
      mapData: [],
      gmap: null,
      mark: {
        lat: 0,
        lon: 0,
      },
      latt: 0,
      lonn: 0,
    };
    
  },
  mounted() {
    this.getMap();
    this.getMapDetails();
  },
  methods: {
    getMap() {
      this.gmap = new google.maps.Map(document.getElementById("googlemap"), {
        center: { lat: 20.5937, lng: 78.9629 },
        zoom: 5,
      });
    },
    getMapDetails() {
      axios({
        method: "get",
        url: "/beekeepers/nearby/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          for (let j = 0; j < response.data.data.length; j++) {
            this.mapData.push(response.data.data[j]);
          }
       
          for (let i = 0; i < response.data.data.length; i++) {
            this.latt = response.data.data[i].location[1];
            this.lonn = response.data.data[i].location[0];
             this.icons = {
                url: require("../../assets/images/beeIcon.png"),
                size: new google.maps.Size(46, 50),
                scaledSize: new google.maps.Size(32, 35),
                anchor: new google.maps.Point(0, 50),
              };
            this.marker = new google.maps.Marker({
              position: { lat: this.latt, lng: this.lonn },
              map: this.gmap,
              icon:this.icons
              // icon:"../../assets/images/beeIcon.png"
            });

            const infowindow = new google.maps.InfoWindow({
              
              content: String(
                "<h2>" +
                  this.mapData[i].sellerProfileId.displayName +
                  "</h2>" +
                  "<br>" +
                  
                '<a href="/beekeeperProducts/' +
                this.mapData[i]._id +
                '"><button class="RB medium" >View Details</button></a>'
              ),
              maxWidth: 500,
             
            });
            this.marker.addListener("click", (eve) => {
              infowindow.open(this.map3, this.marker);
              infowindow.setPosition(eve.latLng);
            });
          }
        } else {
          console.log("failed to get the mapdetails");
        }
      });
    },
    markk(gmap, marker) {
      const infowindow = new google.maps.InfoWindow({
        content: "contjmjentString",
      });
      this.marker.addListener("click", () => {
        infowindow.open(gmap, marker);
      });
    },
  },
};
</script>
<style scoped>
#googlemap {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>